<div class="link-component">
    <!-- Hack to allow usage in grids and display data fields; this is to be removed -->
    <!-- as soon as a better solution is available. When caption is '-o-' the caption, -->
    <!-- help text and validation message is hidden. -->
    @if (caption() === '-o-') {
        <dx-text-box #dx valueChangeEvent="keyup" (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [readOnly]="readonly()" [isValid]="isValid" [value]="value()"
                [name]="caption()" [disabled]="disabled()"></dx-text-box>
    }
    @else {
        <app-layout-control>
            <app-control-label top [control]="control" [caption]="caption()"></app-control-label>
            <dx-text-box #dx valueChangeEvent="keyup" (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [readOnly]="readonly()" [isValid]="isValid" [value]="value()"
                [name]="caption()" [disabled]="disabled()"></dx-text-box>
            <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [calculateValidationText]="calculateValidationText()"
                [helpText]="helpText()" [isValid]="isValid"></app-control-supporting-text>
        </app-layout-control>
    }
</div>
